import Main from './index.vue'

export default [
  {
    path: '/devices', component: Main, meta: { auth: true },
  }
]